// extracted by mini-css-extract-plugin
module.exports = {"button":"_7a3fb80146--button--zgCz0"};